import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PageTitle from "../../../layouts/PageTitle";

class CkEditor extends Component {
    render() {
        return (
            <>
                <PageTitle activeMenu="CkEditor" motherMenu="Form" pageContent="CkEditor" />
                <div className="row">
                    <div className="col-xl-12 col-xxl-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Form CkEditor</h4>
                            </div>
                            <div className="card-body custom-ekeditor">
                                <CKEditor
                                    editor={ClassicEditor}
                                    onReady={editor => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CkEditor;

// - un endpoint qui qui propose les reccettes que l'utilisateur a l'habitude de consommer en fonction de sa rechercher ou filtre.

//  ENDPOINT DE GENERATION DU PLAN

// ici c'est un problem de fiabili

// - verifier que  la somme des macronutriment dans total "totalNV" des reccettes est etre egal au macronutriment dans  "dailyGoal"
// -

// - verifier que le programme generer contient tout les plans souhaiter par l'utilisateur
// - verifier que chaque plan contient la date a la quel l'utilisateur a souhaiter generer ce plan
// - 